import type { FC, ReactNode } from 'react'
import React from 'react'
import { Typography as MuiTypography } from '@material-ui/core'

interface IProps {
  children?: ReactNode
}

const Typography: FC<IProps> = ({ children, ...rest }) => {
  return <MuiTypography {...rest}>{children}</MuiTypography>
}

export default Typography as typeof MuiTypography
